enum SectionStatus {
	COMPLETE = 'Complete',
	REQUIRED = 'Required',
	NOT_ELIGIBLE = 'Not Eligible',
	NOT_REQUIRED = 'Not Required',
	IN_THE_WORKS = 'In The Works',
	UNKNOWN = 'Unknown',
}

export default SectionStatus;